import React from 'react';

// Standard NFPA 704 diamond (square rotated 45°)
// Equal width and height (1:1 ratio) matching the reference image.
// Layout:
//   Top quadrant   = Red (Flammability / fire)
//   Right quadrant = Yellow (Reactivity)
//   Bottom quadrant= White (Special)
//   Left quadrant  = Blue (Health)
export default function NFPADiamond({
  health = 0,
  fire = 0,
  reactivity = 0,
  special = '-',
  width = 100,
}) {
  const VB = 120; // viewBox size with padding for outer stroke
  const PAD = 10;
  const SIZE = VB - 2 * PAD; // 100

  // Outer diamond vertices (within padded viewBox)
  const TOP = [VB / 2, PAD];
  const RIGHT = [VB - PAD, VB / 2];
  const BOTTOM = [VB / 2, VB - PAD];
  const LEFT = [PAD, VB / 2];

  // Mid-points of the four edges
  const MID_TR = [(TOP[0] + RIGHT[0]) / 2, (TOP[1] + RIGHT[1]) / 2];
  const MID_BR = [(RIGHT[0] + BOTTOM[0]) / 2, (RIGHT[1] + BOTTOM[1]) / 2];
  const MID_BL = [(BOTTOM[0] + LEFT[0]) / 2, (BOTTOM[1] + LEFT[1]) / 2];
  const MID_TL = [(LEFT[0] + TOP[0]) / 2, (LEFT[1] + TOP[1]) / 2];
  const C = [VB / 2, VB / 2];

  const poly = (pts) => pts.map((p) => p.join(',')).join(' ');

  const topPoly = poly([TOP, MID_TR, C, MID_TL]);
  const rightPoly = poly([MID_TR, RIGHT, MID_BR, C]);
  const bottomPoly = poly([C, MID_BR, BOTTOM, MID_BL]);
  const leftPoly = poly([MID_TL, C, MID_BL, LEFT]);

  // Centroids (centers of each colored sub-diamond) used for label placement
  const centroid = (pts) => [
    pts.reduce((s, p) => s + p[0], 0) / pts.length,
    pts.reduce((s, p) => s + p[1], 0) / pts.length,
  ];
  const [tx, ty] = centroid([TOP, MID_TR, C, MID_TL]);
  const [rx, ry] = centroid([MID_TR, RIGHT, MID_BR, C]);
  const [bx, by] = centroid([C, MID_BR, BOTTOM, MID_BL]);
  const [lx, ly] = centroid([MID_TL, C, MID_BL, LEFT]);

  const stroke = '#0a0a0a';
  const sw = 2.5;

  // Font size relative to width (slightly smaller for cleaner look)
  const fontSize = SIZE * 0.26;
  const specialFontSize = String(special).length > 1 ? SIZE * 0.18 : SIZE * 0.22;

  return (
    <svg
      width={width}
      height={width}
      viewBox={`0 0 ${VB} ${VB}`}
      className="select-none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <polygon points={topPoly} fill="#dc2626" stroke={stroke} strokeWidth={sw} strokeLinejoin="miter" />
      <polygon points={rightPoly} fill="#facc15" stroke={stroke} strokeWidth={sw} strokeLinejoin="miter" />
      <polygon points={bottomPoly} fill="#ffffff" stroke={stroke} strokeWidth={sw} strokeLinejoin="miter" />
      <polygon points={leftPoly} fill="#2563eb" stroke={stroke} strokeWidth={sw} strokeLinejoin="miter" />

      {/* Outer diamond outline */}
      <polygon
        points={poly([TOP, RIGHT, BOTTOM, LEFT])}
        fill="none"
        stroke={stroke}
        strokeWidth={sw}
        strokeLinejoin="miter"
      />

      {/* Numbers / text */}
      <text
        x={tx}
        y={ty}
        textAnchor="middle"
        dominantBaseline="central"
        fontSize={fontSize}
        fontWeight="normal"
        fill="#ffffff"
        fontFamily="Arial, sans-serif"
      >
        {fire}
      </text>
      <text
        x={rx}
        y={ry}
        textAnchor="middle"
        dominantBaseline="central"
        fontSize={fontSize}
        fontWeight="normal"
        fill="#0a0a0a"
        fontFamily="Arial, sans-serif"
      >
        {reactivity}
      </text>
      <text
        x={bx}
        y={by}
        textAnchor="middle"
        dominantBaseline="central"
        fontSize={specialFontSize}
        fontWeight="normal"
        fill="#0a0a0a"
        fontFamily="Arial, sans-serif"
      >
        {special}
      </text>
      <text
        x={lx}
        y={ly}
        textAnchor="middle"
        dominantBaseline="central"
        fontSize={fontSize}
        fontWeight="normal"
        fill="#ffffff"
        fontFamily="Arial, sans-serif"
      >
        {health}
      </text>
    </svg>
  );
}
